var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.654,
    height: 26.654,
    viewBox: "0 0 26.654 26.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M30.238,16.577a11.907,11.907,0,0,1-1.279,5.4,12.077,12.077,0,0,1-10.8,6.678,11.907,11.907,0,0,1-5.4-1.279l-6.034.378.635-5.777a11.907,11.907,0,0,1-1.279-5.4,12.077,12.077,0,0,1,6.678-10.8,11.907,11.907,0,0,1,5.4-1.279h.71A12.049,12.049,0,0,1,30.238,15.867Z",
    transform: "translate(-6.084 -4.5)",
    fill: "none",
    stroke: "#9b9cad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M-527.145-1828h9.7",
    transform: "translate(534.759 1842.85)",
    fill: "none",
    stroke: "#9b9cad",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M-527.145-1828h4.016",
    transform: "translate(534.759 1837.303)",
    fill: "none",
    stroke: "#9b9cad",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.c829a7714a16f417580c1b9f95f57b36.svg";
export { ForwardRef as ReactComponent };